import { useState } from 'react'
import { Plus as PlusIcon } from 'react-feather'

import { useHistory } from 'react-router-dom'
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Tab,
  TablePagination,
  Tabs,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { useTheme } from '@material-ui/styles'

import {
  Container,
  ContentHeader,
  FilterButton,
  LoadingFeedback,
  Page,
  Permitted,
} from 'components'
import { UsersTable, UserExportDialog } from 'components/Users'
import { UserFilter } from './components'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePagination from 'hooks/usePagination'

import constants from 'constants/index'
import * as service from 'service'
import { routes } from 'Routes'

const UsersMain = () => {
  const filter = useFilter()
  const history = useHistory()
  const [tab, setTab] = useState(constants.user.ALL_TAB)
  const [open, setOpen] = useState(false)

  const theme = useTheme()
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { refresh, response, isStillLoading } = useFetch(
    service.backoffice.users.get,
    {
      ...{ ...filter.filters },
      ...(tab !== constants.user.ALL_TAB && {
        active: tab === constants.user.ACTIVE_TAB,
      }),
      perPage,
      page,
      minimal: true,
    },
    [page, perPage, filter.filters],
  )

  const handleChangeTab = (_, value) => {
    setTab(value)
    if (value !== constants.user.ALL_TAB) {
      return filter.setFilters({
        ...filter.filters,
        active: `${value === constants.user.ACTIVE_TAB}`,
      })
    }

    const filters = filter.filters
    delete filters.active
    filter.setFilters({ ...filters })
  }

  return (
    <>
      <Page title="Listagem Usuários">
        <LoadingFeedback open={isStillLoading} />
        <Container
          maxWidth={false}
          spacingXl={30}
          spacingLg={25}
          spacingMd={10}
          spacingSm={10}
        >
          <ContentHeader
            menu="Usuários"
            title="Listagem"
            subtitle="Exibição dos usuários"
          >
            <Permitted
              someTags={[
                constants.permissions.USERS.LIST,
                constants.permissions.USERS.EXPORT,
              ]}
            >
              <Box mr={1}>
                <Button
                  onClick={() => setOpen(true)}
                  variant="contained"
                  color="secondary"
                >
                  EXPORTAR
                </Button>
              </Box>
            </Permitted>
            <Box ml={1}>
              <FilterButton setDrawerOpen={filter.setDrawerOpen} />
            </Box>
          </ContentHeader>
          <Box
            mt={4}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Tabs
              value={tab}
              onChange={handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
            >
              {constants.user.TABS.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  onClick={(event) => handleChangeTab(event, tab.value)}
                />
              ))}
            </Tabs>
          </Box>
          <Card>
            <Box width="100%">
              <Grid container>
                <Grid item xs={6}>
                  <Box
                    width="100%"
                    p={2}
                    height="100%"
                    display="flex"
                    alignItems="center"
                  >
                    <Typography variant="h5">Usuários</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box p={2} display="flex" justifyContent="flex-end">
                    <Permitted tag={constants.permissions.USERS.CREATE}>
                      <Button
                        onClick={() => history.push(routes.users.new)}
                        variant="outlined"
                        color="primary"
                        startIcon={<PlusIcon />}
                      >
                        Criar
                      </Button>
                    </Permitted>
                  </Box>
                </Grid>
              </Grid>
              <Divider />
            </Box>
            <UsersTable
              users={response?.data?.users || []}
              profileType={constants.user.PROFILE_TYPE_CLIENT}
              refresh={refresh}
            />
            <Box px={2} display="flex" justifyContent="flex-end">
              <TablePagination
                component="div"
                count={response?.data?.meta?.totalCount || 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                page={page - 1}
                rowsPerPage={perPage}
                rowsPerPageOptions={[5, 10, 25, 100]}
                labelRowsPerPage={isDesktop ? 'Por página' : ''}
                nextIconButtonProps={{ size: 'small' }}
                backIconButtonProps={{ size: 'small' }}
              />
            </Box>
          </Card>
        </Container>

        <UserFilter filter={filter} />
      </Page>
      <UserExportDialog
        filters={filter.filters}
        open={open}
        setOpen={setOpen}
        userClient
      />
    </>
  )
}

export default UsersMain
